/**
 * PDF Explorer uses individual inputs rather than a single params object.
 * Each preset maps input names to their values.
 */

/** Linear PDF: f(x) = 2x/9 on [0, 3] */
const LINEAR_CURVE_DATA: number[][] = Array.from({ length: 61 }, (_, i) => {
  const x = (i / 60) * 3;
  return [x, (2 / 9) * x];
});

/** Uniform PDF: f(x) = 1/3 on [0, 3] */
const UNIFORM_CURVE_DATA: number[][] = Array.from({ length: 61 }, (_, i) => {
  const x = (i / 60) * 3;
  return [x, 1 / 3];
});

export const PDF_EXPLORER_DEFAULT: Record<string, unknown> = {
  curveData: LINEAR_CURVE_DATA,
  pdfCoeffs: [0, 2 / 9],
  domainMin: 0,
  domainMax: 3,
  initialA: 1,
  initialB: 2.5,
  xMin: 0,
  xMax: 3.4,
  yMax: 0.75,
  xInterval: 1,
  curveColor: '#3b82f6',
  boundsColor: '#f97316',
  curveLabel: 'f(x)',
  curveLabelCoord: [2.8, 0.6],
};

export const PDF_EXPLORER_UNIFORM: Record<string, unknown> = {
  curveData: UNIFORM_CURVE_DATA,
  pdfCoeffs: [1 / 3],
  domainMin: 0,
  domainMax: 3,
  initialA: 0.5,
  initialB: 2,
  xMin: -0.2,
  xMax: 3.4,
  yMax: 0.55,
  xInterval: 1,
  curveColor: '#6366f1',
  boundsColor: '#f97316',
  curveLabel: 'f(x) = 1/3',
  curveLabelCoord: [2.8, 0.38],
};

export const PDF_EXPLORER_PRESETS: Record<string, Record<string, unknown>> = {
  default: PDF_EXPLORER_DEFAULT,
  uniform: PDF_EXPLORER_UNIFORM,
};
